// import { Directive } from '@angular/core';
import { Directive, HostListener, Output, EventEmitter } from "@angular/core";

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: "[dropzone]"
})
export class DropzoneDirective {
  @Output() dropped = new EventEmitter<FileList>();
  @Output() hovered = new EventEmitter<boolean>();

  @HostListener("drop", ["$event"])
  onDrop($event) {
    $event.preventDefault();
    this.dropped.emit($event.dataTransfer.files);
    this.hovered.emit(false);
  }

  @HostListener("dragover", ["$event"])
  onDragOver($event) {
    $event.preventDefault();
    this.hovered.emit(true);
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave($event) {
    $event.preventDefault();
    this.hovered.emit(false);
  }
}
//   import { Directive, HostListener, Output, EventEmitter } from "@angular/core";

// @Directive({
//   selector: "[appDropzone]"
//   // selector: '[dropzone]'
// })
// export class DropzoneDirective {
//   @Output() dropped = new EventEmitter<FileList>();
//   @Output() hovered = new EventEmitter<boolean>();

//   @HostListener("drop", ["$event"])
//   onDrop($event) {
//     $event.preventDefault();
//     this.dropped.emit($event.dataTransfer.files);
//     this.hovered.emit(false);
//   }

//   @HostListener("dragover", ["$event"])
//   onDragOver($event) {
//     $event.preventDefault();
//     this.hovered.emit(true);
//   }

//   @HostListener("dragleave", ["$event"])
//   onDragLeave($event) {
//     $event.preventDefault();
//     this.hovered.emit(false);
//   }
// }
